import { Icon } from 'components/icon'
import React from 'react'
import { TitleBoxProps } from './types'

export const TitleBox: React.FC<TitleBoxProps> = ({ title, icon }) => {
	return (
		<div className="flex items-center gap-4 mb-4">
			{icon && <Icon src={icon} className="w-6 h-6" />}
			<h3 className="text-2xl text-gray-18 font-bold font-Inter">{title}</h3>
		</div>
	)
}
